import Vue from "vue";
import Router from "vue-router";
import LoginComponent from "./views/Login.vue";
import SignUpComponent from "./views/SignUp.vue";
import AccountActivation from "./views/AccountActivation.vue";
import ResetPasswordComponent from "./views/ResetPassword.vue";
import Home from "./views/Home.vue";
import User from "./views/User.vue";


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: {
        name: "home"
      }
    },
    {
      path: "/login",
      name: "login",
      component: LoginComponent
    },
    {
      path: "/sign-up",
      name: "signUp",
      component: SignUpComponent
    },
    {
      path: "/activate-account/:token?",
      component: AccountActivation,
      name: "accountActivation"
    },
    {
      path: "/reset-password",
      name: "resetPassword",
      component: ResetPasswordComponent
    },
    {
      path: "/confirm-password-reset/:token?",
      name: "resetPasswordConfirm",
      component: ResetPasswordComponent
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/user",
      name: "User",
      icon: "account_box",
      color: "orange",
      component: User
    },
    
  ]
});
